import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useEffect } from 'react';
import { useState } from 'react';

export default function DropSelect(props) {
  const [defaultValue, setDefaultValue] = useState("");
  useEffect(() => {
    setDefaultValue(props.value)
    console.log('defaultValue changed', props?.value)
  }, [props.value]);

  useEffect(() => {
    setDefaultValue(props.value)
    console.log('defaultValue', props?.value)
  }, []);
  console.log('defaultValue', props?.value)

  return (
    <Autocomplete
      disablePortal
      id="disabled-options-demo"
      className={`${props.className}`}
      // id="combo-box-demo"
      // style={{ maxWidth: 180 }}
      options={props.list}
      getOptionDisabled={(option) =>
        option?.active === false
      }
      getOptionLabel={(option) =>props?.title?.includes("Select the scholarship program")? option?.programType && !option?.active ? `${option?.programType} (No longer accepting applications)`:option?.programType ?? "": option}
      sx={{ width: 300,textAlign:'left',display: 'flex', alignItems: 'flex-end',float:'left' }}
      value={defaultValue}
      onChange={(e, value)=>props.onChange(value)}
      renderInput={(params) => <TextField {...params} placeholder={props.placeholder} label={props.title} />}
    />
  );
}
